'use client';
import cn from 'classnames';
import Image from 'next/image';

import Link from '@/components/common/Link/Link';

import { useContextBroker } from '@/components/context/ContextBroker/useContextBroker';

import ChevronLeft from 'public/img/icon/chevron-down-black-carousel.svg';

import './BackToNav.style.scss';

type BackToNavProps = {
  className?: string;
  copy: string;
  handleBackTo?: () => void;
  href: string;
  /** Retrace the entry path with `history.back()` instead of a fixed `href` — falls back to `href` when there's no history to return to (e.g. a direct deep-link entry). */
  useBrowserHistory?: boolean;
};

function BackToNavContent({ copy }: { copy: string }) {
  return (
    <>
      <Image
        className='BackToNav-arrow'
        src={ChevronLeft}
        height={16}
        width={12}
        alt=''
      />
      {copy}
    </>
  );
}

function BackToNav(props: BackToNavProps) {
  const { className = '', copy, handleBackTo, href, useBrowserHistory } = props;
  const { isIOSWebView } = useContextBroker();

  const handleIOSClick = useBrowserHistory
    ? (event: React.MouseEvent<HTMLAnchorElement>) => {
        if (window.history.length > 1) {
          event.preventDefault();
          window.history.back();
        }
      }
    : undefined;

  return (
    <div className={cn('BackToNav', className)}>
      {isIOSWebView ? (
        // iOS doesn't play well with NextLink
        <a
          className='Link link-m compact'
          href={href}
          onClick={handleIOSClick}
        >
          <BackToNavContent copy={copy} />
        </a>
      ) : handleBackTo ? (
        <button onClick={handleBackTo}>
          <BackToNavContent copy={copy} />
        </button>
      ) : (
        <Link
          compact
          href={href}
        >
          <BackToNavContent copy={copy} />
        </Link>
      )}
    </div>
  );
}

export default BackToNav;
